import Card from "./card"
import { PropTypes } from 'prop-types';

const Cards = ({cards}) => {
   
    return (
        cards?.length > 0 ?
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 px-6 py-8 lg:p-32 bg-[#fafafd]">
                {
                    cards?.map((card, index) => (
                        <Card key={index} {...card} />
                    ))
                }
            </div>
            :
            <div className="flex justify-center items-center w-full h-96">
                <span className="text-2xl text-center font-semibold text-gray-400">No Data Found</span>
            </div>

    )
}
Cards.propTypes = {
    cards: PropTypes.array
}
export default Cards